/**
 * 币对分析服务
 */

import { apiClient } from './apiClient';

export class CoinAnalysisService {
  /**
   * 处理币对名称，将合约格式转换为现货格式
   */
  private processSymbolName(symbol: string): string {
    // 移除合约后缀，如 -SWAP, -FUTURES 等
    let processedSymbol = symbol;

    // 常见的合约后缀
    const contractSuffixes = ['-SWAP', '-FUTURES', '-PERP', '-PERPETUAL', '-USDT-SWAP', '-USDT-FUTURES'];

    for (const suffix of contractSuffixes) {
      if (processedSymbol.endsWith(suffix)) {
        processedSymbol = processedSymbol.replace(suffix, '');
        break;
      }
    }

    // 确保以USDT结尾
    if (!processedSymbol.endsWith('-USDT')) {
      processedSymbol = processedSymbol + '-USDT';
    }

    return processedSymbol;
  }

  /**
   * 获取币对分析详情
   */
  async getCoinAnalysisDetail(instId: string): Promise<any> {
    // 处理币对名称，将合约格式转换为现货格式
    const processedInstId = this.processSymbolName(instId);

    const response = await apiClient.get<any>(`/coin-analysis/${processedInstId}`);

    if (!response.success) {
      throw new Error(response.message || `获取币对 ${instId} 分析详情失败`);
    }

    return response.data;
  }

  /**
   * 将币对添加到AI分析队列
   */
  async addCoinToAnalysisQueue(symbol: string): Promise<any> {
    const response = await apiClient.post<any>('/coin-analysis/queue', {
      symbol,
    });

    if (!response.success) {
      throw new Error(response.message || '添加币对到分析队列失败');
    }

    return response.data;
  }

  /**
   * 获取分析队列状态
   */
  async getAnalysisQueueStatus(): Promise<any> {
    const response = await apiClient.get<any>('/coin-analysis/queue/status');

    if (!response.success) {
      throw new Error(response.message || '获取分析队列状态失败');
    }

    return response.data;
  }
}

export const coinAnalysisService = new CoinAnalysisService();
